/* eslint no-unused-vars: off, @typescript-eslint/no-unused-vars: off */
/**
 * User Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.3.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Permissions schema for create
 * @export
 * @interface PermissionsCreate
 */
export interface PermissionsCreate {
    /**
     * @type {string}
     * @memberof PermissionsCreate
     */
    name: string;
    /**
     * @type {string}
     * @memberof PermissionsCreate
     */
    dm_zone?: string;
    /**
     * @type {string}
     * @memberof PermissionsCreate
     */
    dm_device?: string;
    /**
     * @type {string}
     * @memberof PermissionsCreate
     */
    user_management?: string;
    /**
     * @type {string}
     * @memberof PermissionsCreate
     */
    fmw_management?: string;
    /**
     * @type {string}
     * @memberof PermissionsCreate
     */
    http_sender?: string;
    /**
     * @type {string}
     * @memberof PermissionsCreate
     */
    rmq_sender?: string;
    /**
     * @type {string}
     * @memberof PermissionsCreate
     */
    monitoring?: string;
    /**
     * @type {string}
     * @memberof PermissionsCreate
     */
    raw_messages?: string;
    /**
     * @type {string}
     * @memberof PermissionsCreate
     */
    devices?: string;
    /**
     * @type {string}
     * @memberof PermissionsCreate
     */
    stations?: string;
    /**
     * @type {string}
     * @memberof PermissionsCreate
     */
    provisioning?: string;
    /**
     * @type {boolean}
     * @memberof PermissionsCreate
     */
    template?: boolean;
}
